import { Group } from '../../group/models/group';
import { IModuleGroupQuery } from '../interfaces/module-group.query.interface';

export class ModuleGroup extends Group {
    static props_to_search = ['name'];

    module: {
        id: string;
    };

    constructor(query?: IModuleGroupQuery) {
        super(query);

        if (query && query.module) {
            this.module = {
                id: query.module.id.toString(),
            };
        } else {
            this.module = {
                id: null,
            };
        }
    }
}
